import querystring from 'querystring';
import { getEventLinks } from '../../helpers/event-search';
import { fetchManagementTags } from '../../services/killshot';
import { isDef, isStringEmpty } from '../../shared/utils/validations';
import { killshotApi, hallpassApi } from '../../api';

const KILLSHOT_GETTING_HEADLINER = 'KILLSHOT_GETTING_HEADLINER';
const KILLSHOT_GETTING_HEADLINER_SUCCESS = 'KILLSHOT_GETTING_HEADLINER_SUCCESS';
const KILLSHOT_GETTING_EVENTS = 'KILLSHOT_GETTING_EVENTS';
const KILLSHOT_GETTING_USERS = 'KILLSHOT_GETTING_USERS';
const KILLSHOT_GETTING_USERS_SUCCESS = 'KILLSHOT_GETTING_USERS_SUCCESS';
const KILLSHOT_GETTING_ASSIGNEES_SUCCESS = 'KILLSHOT_GETTING_ASSIGNEES_SUCCESS';
const KILLSHOT_GETTING_TAGS = 'KILLSHOT_GETTING_TAGS';
const KILLSHOT_GETTING_TAGS_SUCCESS = 'KILLSHOT_GETTING_TAGS_SUCCESS';

export const gettingHeadliners = bool => ({ type: KILLSHOT_GETTING_HEADLINER, payload: bool });
export const gettingUsers = bool => ({ type: KILLSHOT_GETTING_USERS, payload: bool });
export const gettingTags = bool => ({ type: KILLSHOT_GETTING_TAGS, payload: bool });
export const gettingEvents = bool => ({
  type: KILLSHOT_GETTING_EVENTS,
  payload: bool,
});
export const getHeadlinersSuccess = headliners => ({ type: KILLSHOT_GETTING_HEADLINER_SUCCESS, payload: headliners });
export const getUsersSuccess = users => ({ type: KILLSHOT_GETTING_USERS_SUCCESS, payload: users });
const getAssigneesSuccess = assignees => ({ type: KILLSHOT_GETTING_ASSIGNEES_SUCCESS, payload: assignees });
const getTagsSuccess = tags => ({ type: KILLSHOT_GETTING_TAGS_SUCCESS, payload: tags });

/**
 * Fetch headliners to display on killshot
 * @param {string} assigneeFilterValue
 */
export const getHeadLiners = assigneeFilterValue => dispatch => {
  dispatch(gettingHeadliners(true));

  let url = `v1/management/headliners`;

  const hasPricerAssigned = isDef(assigneeFilterValue) && !isStringEmpty(assigneeFilterValue);
  if (hasPricerAssigned) url += `?pricer=${assigneeFilterValue}`;

  return killshotApi
    .get(url)
    .then(res => {
      dispatch(getHeadlinersSuccess(res.response));
      dispatch(gettingHeadliners(false));
      return res.response;
    })
    .catch(error => {
      dispatch(gettingHeadliners(false));
      return error;
    });
};

/**
 * Fetch for each event data for the ag grid
 * @param {array} events
 * @param {number} page
 */
export const fetchEvents = (events, page, sortModel) => dispatch => {
  dispatch(gettingEvents(true));
  const paramsSearch = {
    page,
    id: events.map(e => e.id),
  };

  if (sortModel.length) {
    const { colId, sort } = sortModel[0];
    paramsSearch.sort_column = colId;
    paramsSearch.sort_order = sort.toUpperCase();
  }

  const url = `v1/kim_event/`;

  return killshotApi
    .get(url, {
      params: paramsSearch,
      paramsSerializer: params => {
        return querystring.stringify(params);
      },
    })
    .then(response => {
      if (response && response.response && response.response.events) {
        const rows = response.response.events.map(event => {
          return {
            event,
            id: event.event_id,
            venue_name: event.venue.name,
            event_date: event.event_datetime,
            sb_total_num_held: event.sb_stats.total_num_held,
            sb_total_num_sold: event.sb_stats.total_num_sold,
            ...event.sb_stats,
            links: event.links,
            cota: `$${event.cota.toLocaleString()}`,
            event_links: getEventLinks(event.links, event.event_id, event.skybox_sales_link, event.reps_links),
          };
        });

        const result = {
          rows,
          currentPage: response.response.page,
          totalEvents: response.response.total_events,
        };
        return result;
      }
      return null;
    });
};

/**
 * Fetch users to get the pricers
 */
export const getUsers = () => dispatch => {
  dispatch(gettingUsers(true));
  hallpassApi
    .get(`v0/users`)
    .then(res => {
      dispatch(getUsersSuccess(res.users));
      dispatch(gettingUsers(false));
    })
    .catch(error => {
      dispatch(gettingUsers(false));
      throw error;
    });
};

/**
 * Fetch tags list for pricing
 */
export const getTags = () => async dispatch => {
  dispatch(gettingTags(true));
  const response = await fetchManagementTags();
  dispatch(getTagsSuccess(response));
  dispatch(gettingTags(false));
};

/**
 * assignUserToEvent
 * @param {number} eventID Id if the Event
 * @param {string} pricerTag User to be assigned
 */
export const assignUserToEvent = (eventID, pricerTag) => dispatch => {
  killshotApi
    .post(`v0/management/assign_pricer`, {
      assignee: pricerTag,
      events: [eventID],
    })
    .then(res => {
      dispatch(getAssigneesSuccess(res.asssignees));
    })
    .catch(error => {
      throw error;
    });
};
